import { Loader2 } from "lucide-react";

/**
 * Pantalla completa "Descargando…" que se muestra mientras el backend genera
 * un documento (formato de vacaciones en PDF, responsiva en Word, etc.).
 * Bloquea la interacción para que el usuario no dispare la descarga dos veces.
 */
export function DescargandoOverlay({
  visible,
  titulo = "Descargando…",
  detalle = "Estamos generando el documento, espera un momento.",
}: {
  visible: boolean;
  titulo?: string;
  detalle?: string;
}) {
  if (!visible) return null;
  return (
    <div
      className="fixed inset-0 z-[100] bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="bg-white rounded-xl shadow-2xl px-10 py-8 flex flex-col items-center gap-4 max-w-sm w-full text-center">
        <Loader2 className="w-12 h-12 text-emerald-600 animate-spin" />
        <div className="text-lg font-semibold text-slate-900">{titulo}</div>
        <div className="text-sm text-slate-500">{detalle}</div>
      </div>
    </div>
  );
}
